import { lazy } from 'react';

const ProductsInvoices = lazy(() => import('./ProductsInvoices'));

export default ProductsInvoices;
